import React, { useMemo, useState } from "react";

import {
  buildEvidenceDataGroups,
  formatEvidenceValue,
} from "./responseData.mjs";

const DEFAULT_VISIBLE_ROWS = 6;

const EvidenceDataUsed = ({ facts, citations }) => {
  const groups = useMemo(
    () => buildEvidenceDataGroups(facts, citations),
    [facts, citations]
  );
  const [expandedDatasets, setExpandedDatasets] = useState({});

  if (!groups.length) return null;

  const toggleDataset = (datasetId) => {
    setExpandedDatasets((current) => ({
      ...current,
      [datasetId]: !current[datasetId],
    }));
  };

  return (
    <section className="facility-ai-data-used">
      <h3>Data used</h3>
      <p className="facility-ai-section-intro">
        Verified values that directly support this answer.
      </p>
      <div className="facility-ai-data-groups">
        {groups.map((group) => (
          <article className="facility-ai-data-group" key={group.id}>
            <h4>{group.label}</h4>
            {group.datasets.map((dataset) => {
              const expanded = Boolean(expandedDatasets[dataset.id]);
              const visibleRows = expanded
                ? dataset.rows
                : dataset.rows.slice(0, DEFAULT_VISIBLE_ROWS);
              return (
                <div className="facility-ai-dataset" key={dataset.id}>
                  <div className="facility-ai-dataset-heading">
                    <h5>{dataset.title}</h5>
                    <span>
                      {dataset.rows.length} {dataset.rows.length === 1 ? "record" : "records"}
                    </span>
                  </div>
                  <div className="facility-ai-data-table-wrap">
                    <table>
                      <thead>
                        <tr>
                          {dataset.columns.map((column) => (
                            <th key={column.key}>{column.label}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {visibleRows.map((row) => (
                          <tr key={row.id}>
                            {dataset.columns.map((column) => (
                              <td key={`${row.id}-${column.key}`}>
                                {formatEvidenceValue(
                                  row.cells[column.key],
                                  row.units[column.key]
                                )}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {dataset.rows.length > DEFAULT_VISIBLE_ROWS ? (
                    <button
                      type="button"
                      className="facility-ai-data-toggle"
                      onClick={() => toggleDataset(dataset.id)}
                    >
                      {expanded
                        ? "Show fewer records"
                        : `Show all ${dataset.rows.length} records`}
                    </button>
                  ) : null}
                </div>
              );
            })}
            {group.metrics.length ? (
              <dl className="facility-ai-data-metrics">
                {group.metrics.map((metric) => (
                  <div key={metric.id}>
                    <dt>{metric.label}</dt>
                    <dd>{formatEvidenceValue(metric.value, metric.unit)}</dd>
                  </div>
                ))}
              </dl>
            ) : null}
          </article>
        ))}
      </div>
    </section>
  );
};

export default EvidenceDataUsed;
